import {
  ZyusetuFieldKeyFragmentFragment,
  ZyusetuFieldKeyType,
} from "@/graphql/graphql";
import {Controller, useFormContext} from "react-hook-form";
import {FormSchema} from "@/components/pages/Zyusetu/ZyusetuEditorSection.tsx";
import {TextField} from "@mui/material";
import {NumericFormat} from "react-number-format";
import {zyusetuValueIntoZodValue} from "@/hooks/useGetFirstContent";

interface ZyusetuNumberFieldProps {
  fieldKey: ZyusetuFieldKeyFragmentFragment;
  onFocus: () => void;
  updateField: (
    keyId: string,
    keyName: string,
    value: FormSchema<ZyusetuFieldKeyType.Number>[string],
  ) => Promise<void>;
  isAvailable: boolean;
}

export function ZyusetuNumberField({
                                     fieldKey,
                                     onFocus,
                                     updateField,
                                     isAvailable,
                                   }: ZyusetuNumberFieldProps) {
  const {control} = useFormContext<FormSchema<ZyusetuFieldKeyType.Number>>();
  return (
    <Controller
      name={fieldKey.keyName}
      control={control}
      render={({field, formState: {errors}, fieldState: {isDirty}}) => (
        <NumericFormat
          disabled={!isAvailable}
          inputRef={field.ref}
          customInput={TextField}
          inputProps={{
            onFocus: onFocus,
            onBlur: async () => {
              if (errors?.[fieldKey.keyName]?.value?.message) return;
              if (!isDirty) return;
              
              await updateField(fieldKey.id, fieldKey.keyName, field.value);
            },
          }}
          value={field.value.value ?? ""}
          onValueChange={(e) => {
            field.onChange(zyusetuValueIntoZodValue(fieldKey, e.floatValue));
          }}
          error={!!errors?.[fieldKey.keyName]?.value?.message}
          helperText={errors?.[fieldKey.keyName]?.value?.message as string}
          suffix={fieldKey.keyStyle.suffix ?? undefined}
          prefix={fieldKey.keyStyle.prefix ?? undefined}
          allowLeadingZeros={false}
          thousandSeparator={
            fieldKey.keyStyle.thousandSeparator ? "," : undefined
          }
          margin="none"
          fullWidth
          size={"small"}
        />
      )}
    />
  );
}
